<template>
  <div class="learning_content-item" @click="handleXSclick">
    <div class="learning_viewedTime">
      <img src="../assets/web/Browse.png" alt />
      <span>{{ $t("message.viewed_times") }} {{ data.viewedTimes }}</span>
    </div>
    <div class="row learning_content_title">
      <div class="catalog_content_img">
        <img
          v-if="index % 3 == 0"
          src="../assets/web/Card 1.png"
          class="catalog_icon_bg"
        />
        <img
          v-if="index % 3 == 1"
          src="../assets/web/Card 2.png"
          class="catalog_icon_bg"
        />
        <img
          v-if="index % 3 == 2"
          src="../assets/web/Card 3.png"
          class="catalog_icon_bg"
        />
        <img
          v-if="data.iconId"
          :src="`${serverUrl}/servlet/medias/course-ware/icon/${data.iconId}`"
          class="catalog_icon"
        />
      </div>
      <div class="catalog_title_box">
        <div class="catalog_title" :title="data.title">
          <span class="max-line-2"
            >{{
              $t("message.chapter", [
                $t(`message.numberToCN[${data.priority}]`),
              ])
            }}
            {{ data.title }}</span
          >
          <div class="learning_viewedTime_xs">
            <img src="../assets/web/Browse.png" alt />
            <span>&nbsp;{{ data.viewedTimes }}</span>
          </div>
        </div>
        <el-progress
          v-if="!$store.state.isPreview"
          :percentage="data.progress | formatProgress"
          :color="customColor"
          :format="format"
        ></el-progress>
      </div>
    </div>
    <el-progress
      v-if="!$store.state.isPreview"
      :percentage="data.progress | formatProgress"
      :color="customColor"
      :format="format"
    ></el-progress>
    <!-- <div class="m-btn" @click="handleClick">{{btnLabel}}</div> -->
    <div class="chapter_btn">
      <mBtn width="100%" @click="handleClick">{{ btnLabel }}</mBtn>
    </div>
  </div>
</template>

<script>
import mBtn from "./mBtn";
import { serverUrl } from "../api/axios";
export default {
  components: { mBtn },
  props: ["data", "index", "btnLabel"],
  data() {
    return {
      customColor: "#16B695",
      serverUrl: serverUrl,
    };
  },
  computed: {
    wWidth() {
      return this.$store.state.wWidth;
    },
  },
  methods: {
    handleClick() {
      this.$emit("click", this.data, this.index);
    },
    handleXSclick() {
      if (this.wWidth < 976) {
        this.$emit("click", this.data, this.index);
      }
    },
    format() {
      return this.data.fraction;
    },
  },

  created() {},
};
</script>

<style lang="scss" scoped>
</style>